'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _primaryTracker = void 0;

var getPrimaryTracker = exports.getPrimaryTracker = function getPrimaryTracker() {
  if (!_primaryTracker) {
    throw new Error('usage-tracker-container error. "getPrimaryTracker" was be called before "setPrimaryTracker".');
  }

  return _primaryTracker;
};

var setPrimaryTracker = exports.setPrimaryTracker = function setPrimaryTracker(tracker) {
  if (_primaryTracker) {
    throw new Error('usage-tracker-container error. Primary tracker has already been set. You can only set one primary tracker per runtime.');
  }

  _primaryTracker = tracker;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-container/static-1.313/js/index.js
// module id = 407
// module chunks = 3 4